import { KeyboardArrowDownOutlined } from '@mui/icons-material';
import { Box, FormControl, Grid, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ApiGetShopProfile } from '../Core/Apicall';


export interface ShopProfile {
  shopProfileId: number;
  seller_type: "TEAM" | "USER" | "SELLER";
  seller_id: number;
  teamId: number;
  display_name: string;
  banner_url: string;
  logo_url: string;
  theme_color: string;
  is_active: boolean;
  created_by: number;
  updated_by: number | null;
  created_at: string;
  updated_at: string;
}


function Store() {
    const [sortBy, setSortBy] = useState("Highest Selling");
    const {shopProfileId} = useParams()
    const [shopProfile, setShopProfile] = useState<ShopProfile>()
    const {teamId} = useParams()

    const handleChange = (event: SelectChangeEvent) => {
        setSortBy(event.target.value);
    };

      const getShopProfile = async () => {
          try {
            const data = `?teamId=${teamId}`
            const res = await ApiGetShopProfile(data)
            if (res.success || res.status) {
              setShopProfile(res?.data?.data[0])
              // dispatch(setVenderDetails(res?.data[0]))
            }
          } catch (error: any) {
            console.log("Error", error)
            toast.error(error?.message || "Something went wrong");
          }
        }

        useEffect(()=>{
           teamId && getShopProfile()
        },[teamId])

        console.log("Shop Prodile", shopProfile)
    return (
        <Box className='h-content p-3 p-lg-5 w-100'>
            <Box sx={{height:{xs:'18vh', md:"20vh",lg:"30vh",xl:"20vh", background:`url(${shopProfile?.banner_url})`, backgroundSize:'100% 100%',backgroundRepeat:'no-repeat'}}} className="back-img w-100 border position-relative">
                <Box sx={{height:{xs:"100px",sm:"150px",md:"200px"}, width:{xs:"100px",sm:"150px", md:"200px"}, left:{xs:"20px",md:"40px", background:`url(${shopProfile?.logo_url})`, backgroundSize:'100% 100%', backgroundRepeat:'no-repeat'}}} className="store-logo bg-white position-absolute border border-50 top-50">
                </Box>
            </Box>
            <Box sx={{minHeight:{xs:"100px",md:"fit-content"}, marginLeft:{xs:0,md:'15%',xl:"12%"}}} className='d-flex  sort-by align-items-end align-items-md-center p-0 p-md-5 pt-md-5 pt-lg-4 pe-md-0 store-title justify-content-between'>
                <Typography className='text-white fs-32'>{shopProfile?.display_name}</Typography>
                <Box  sx={{height:{xs:'90px',md:"auto"}}}>
                <FormControl sx={{width:"200px"}}>
                    <Select
                        value={sortBy}
                        onChange={handleChange}
                        displayEmpty
                        IconComponent={KeyboardArrowDownOutlined}
                        renderValue={(selected) => (
                            <span>
                                <span className='text-light-white'>Sort by: </span>
                                <span className='text-light-white'>{selected}</span>
                            </span>
                        )}
                        MenuProps={{
                            slotProps: {
                                paper: {
                                    sx: {
                                        background: "var(--primary-color)",
                                        color: "var(--white-color)",
                                        boxShadow: '0px 0xp 10px #000000',

                                        "& .MuiMenuItem-root:hover": {
                                        backgroundColor: "var(--light-white-color)",
                                    },
                                    }

                                }
                            }
                        }}
                    >
                        <MenuItem value="Highest Selling" className=''>Highest Selling</MenuItem>
                        <MenuItem value="Lowest Selling">Lowest Selling</MenuItem>
                        <MenuItem value="Newest">Newest</MenuItem>
                        <MenuItem value="Low to High">Low to High</MenuItem>
                        <MenuItem value="High to Low">High to Low</MenuItem>
                    </Select>
                </FormControl>
                </Box>
            </Box>
            
            <Grid container spacing={{xs:2,md:3}}>
                <Grid size={{xs:6,sm:4,lg:3, xl:2}}>
                    <Box component={'img'} width={'100%'} sx={{height:{xs:"150px",sm:'300px'}}} className='border mb-2' />
                    <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
                    <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
                    <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
                </Grid>
                <Grid size={{xs:6,sm:4,lg:3, xl:2}}>
                    <Box component={'img'} width={'100%'} sx={{height:{xs:"150px",sm:'300px'}}} className='border mb-2' />
                    <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
                    <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
                    <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
                </Grid>
                <Grid size={{xs:6,sm:4,lg:3, xl:2}}>
                    <Box component={'img'} width={'100%'} sx={{height:{xs:"150px",sm:'300px'}}} className='border mb-2' />
                    <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
                    <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
                    <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
                </Grid>
                <Grid size={{xs:6,sm:4,lg:3, xl:2}}>
                    <Box component={'img'} width={'100%'} sx={{height:{xs:"150px",sm:'300px'}}} className='border mb-2' />
                    <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
                    <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
                    <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
                </Grid>
                <Grid size={{xs:6,sm:4,lg:3, xl:2}}>
                    <Box component={'img'} width={'100%'} sx={{height:{xs:"150px",sm:'300px'}}} className='border mb-2' />
                    <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
                    <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
                    <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
                </Grid>
                <Grid size={{xs:6,sm:4,lg:3, xl:2}}>
                    <Box component={'img'} width={'100%'} sx={{height:{xs:"150px",sm:'300px'}}} className='border mb-2' />
                    <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
                    <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
                    <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
                </Grid>
                <Grid size={{xs:6,sm:4,lg:3, xl:2}}>
                    <Box component={'img'} width={'100%'} sx={{height:{xs:"150px",sm:'300px'}}} className='border mb-2' />
                    <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
                    <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
                    <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
                </Grid>
                <Grid size={{xs:6,sm:4,lg:3, xl:2}}>
                    <Box component={'img'} width={'100%'} sx={{height:{xs:"150px",sm:'300px'}}} className='border mb-2' />
                    <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
                    <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
                    <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
                </Grid>
                <Grid size={{xs:6,sm:4,lg:3, xl:2}}>
                    <Box component={'img'} width={'100%'} sx={{height:{xs:"150px",sm:'300px'}}} className='border mb-2' />
                    <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
                    <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
                    <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
                </Grid>
                <Grid size={{xs:6,sm:4,lg:3, xl:2}}>
                    <Box component={'img'} width={'100%'} sx={{height:{xs:"150px",sm:'300px'}}} className='border mb-2' />
                    <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
                    <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
                    <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
                </Grid>
                <Grid size={{xs:6,sm:4,lg:3, xl:2}}>
                    <Box component={'img'} width={'100%'} sx={{height:{xs:"150px",sm:'300px'}}} className='border mb-2' />
                    <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
                    <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
                    <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
                </Grid>
                <Grid size={{xs:6,sm:4,lg:3, xl:2}}>
                    <Box component={'img'} width={'100%'} sx={{height:{xs:"150px",sm:'300px'}}} className='border mb-2' />
                    <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
                    <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
                    <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
                </Grid>
                <Grid size={{xs:6,sm:4,lg:3, xl:2}}>
                    <Box component={'img'} width={'100%'} sx={{height:{xs:"150px",sm:'300px'}}} className='border mb-2' />
                    <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
                    <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
                    <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
                </Grid>
                <Grid size={{xs:6,sm:4,lg:3, xl:2}}>
                    <Box component={'img'} width={'100%'} sx={{height:{xs:"150px",sm:'300px'}}} className='border mb-2' />
                    <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
                    <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
                    <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
                </Grid>
                <Grid size={{xs:6,sm:4,lg:3, xl:2}}>
                    <Box component={'img'} width={'100%'} sx={{height:{xs:"150px",sm:'300px'}}} className='border mb-2' />
                    <Typography className='fs-16 text-white fw-bold' gutterBottom>T-Shirt with Tape Details</Typography>
                    <Typography className='fs-12 text-white' gutterBottom>4.5/5 | (549)</Typography>
                    <Typography className='fs-18 text-white fw-bold'>$ 50</Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Store
